import { Icon } from "@iconify/react";
import { Badge, Box, Button, Divider, IconButton, Popover, Tooltip, Typography } from "@mui/material";
import { useState } from "react";

export default function NotificationsPopover() {
    const [notifications, setNotifications] = useState("");
    const [open, setOpen] = useState(null);

    const handleOpen = (event) => {
      setOpen(event.currentTarget);
    };
    const handleClose = () => {
      setOpen(null);
    };
  
    const handleMarkAllAsRead = () => {
      setNotifications(
        notifications.map((notification) => ({
          ...notification,
          isUnRead: false,
        }))
      );
    };
  
    return (
      <>
        {/* <IconButton color={open ? 'primary' : 'default'} onClick={handleOpen} sx={{ width: 40, height: 40 }}>
          <Badge badgeContent={'2'} color="error">
            <Icon icon="eva:bell-fill" />
          </Badge>
        </IconButton> */}
  
        <Popover
          open={Boolean(open)}
          anchorEl={open}
          onClose={handleClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          PaperProps={{
            sx: {
              mt: 1.5,
              ml: 0.75,
              width: 360,
            },
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', py: 2, px: 2.5 }}>
            <Box sx={{ flexGrow: 1 }}>
              <Typography variant="subtitle1">Notifications</Typography>
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                You have 2 unread messages
              </Typography>
            </Box>
  
            {2 > 0 && (
              <Tooltip title=" Mark all as read">
                <IconButton color="primary" onClick={handleMarkAllAsRead}>
                </IconButton>
              </Tooltip>
            )}
          </Box>
  
          <Divider sx={{ borderStyle: 'dashed' }} />
          <Divider sx={{ borderStyle: 'dashed' }} />
          <Box sx={{ p: 1 }}>
            <Button fullWidth disableRipple>
              View All
            </Button>
          </Box>
        </Popover>
      </>
    );
  }